import firebaseInstance from "../../../util/firebase";

export default {
  changeCompanyTaskDetails(state, item) {
    console.log("changeCompanyTaskDetails", item);
    firebaseInstance
      .database()
      .ref("companies/" + item.companyid)
      .once("value", snap => {
        var companyTasks = snap.val().companyTasks;
        console.log("companyTasks", companyTasks);

        companyTasks[item.taskindex].useDefaultTask = item.useDefaultTask;
        companyTasks[item.taskindex].useTaskRate = item.useTaskRate;
        companyTasks[item.taskindex].taskType = item.taskTypeNew;
        companyTasks[item.taskindex].useTaskCost = item.useTaskCost;
        companyTasks[item.taskindex].hourlyRateOverride =
          item.hourlyRateOverride;
        companyTasks[item.taskindex].hourlyCostOverride =
          item.hourlyCostOverride;
        companyTasks[item.taskindex].hourlyPercentOverride =
          item.hourlyPercentOverride;
        companyTasks[item.taskindex].name = item.name;

        firebaseInstance
          .database()
          .ref("companies/" + item.companyid + "/companyTasks")
          .set(companyTasks, () => {
            console.log("saved moduleColumns info");
          })
          .catch(error => {
            console.log("Error deleting moduleColumns modules", error);
          });
      })
      .catch(error => {
        console.log("Error getting company tasks", error);
      });
  },
  getCompanyInfo(state, item) {
    return new Promise((resolve, reject) => {
      firebaseInstance
        .database()
        .ref("companies/" + item.myCompany)
        .on("value", snap => {
          var companyInfo = snap.val();
          // console.log("company Info", companyInfo);
          if (companyInfo) {
            var data = {
              name: companyInfo.name,
              website: companyInfo.website,
              type: companyInfo.type,
              plan: companyInfo.plan || "free",
              rate: companyInfo.rate,
              cost: companyInfo.cost,
              image: companyInfo.image,
              contingency: companyInfo.contingency,
              projectTemplates: companyInfo.templates,
              companyTasks: _.get(companyInfo, "companyTasks", []),
              phone: companyInfo.phone,
              address: companyInfo.address,
              city: companyInfo.city,
              country: companyInfo.country,
              province: companyInfo.province,
              postalCode: companyInfo.postalCode
            };
            state.commit("SAVE_COMPANY_DATA", data);
            resolve(true);
          } else {
            console.log("Unable to get Company Info", companyInfo);
            resolve(true);
          }
        });
    });
  },
  saveCompanyInfo: (state, item) => {
    var data = {
      name: item.companyName,
      website: item.companyWebsite,
      type: item.companyType,
      rate: item.companyRate,
      // cost: item.companyCost,
      contingency: item.companyContingency,
      phone: item.phone,
      address: item.address,
      city: item.city,
      country: item.country,
      province: item.province,
      postalCode: item.postalCode
    };
    firebaseInstance
      .database()
      .ref("companies/" + item.companyID)
      .update(data, () => {
        state.commit("SAVE_COMPANY_DATA", data);
      })
      .catch(error => {
        console.log("Error saving company data", error);
      });
  },
  deleteUser: (state, item) => {
    var user = firebaseInstance.auth().currentUser;
    user
      .delete()
      .then(() => {
        console.log("user deleted");
      })
      .catch(error => {
        console.log("Error deleting user:", error);
      });
  },
  deleteCompanyTask: (state, item) => {
    console.log("deleteCompanyTask", item);
    firebaseInstance
      .database()
      .ref("companies/" + item.companyid + "/companyTasks")
      .once("value", snap => {
        var companyTasks = snap.val();
        companyTasks.splice(item.index, 1);
        firebaseInstance
          .database()
          .ref("companies/" + item.companyid + "/companyTasks")
          .set(companyTasks, () => {
            console.log("saved companyTasks");
          })
          .catch(error => {
            console.log("Error saving companyTasks", error);
          });
      })
      .catch(error => {
        console.log("Error getting modules 1", error);
      });
  },
  deleteCompanyTaskPhoto: (state, item) => {
    firebaseInstance
      .database()
      .ref(
        "companies/" +
          item.companyid +
          "/companyTasks/" +
          item.index +
          "/taskImage"
      )
      .set("")
      .then(() => {
        console.log("Task image path removed");
        // var object = {url: null}
        // state.commit('SAVE_PROFILE_IMAGE', object)
      })
      .catch(error => {
        console.log(error, "Error deleting task image");
      });
  },
  deleteCompanyPhoto: (state, item) => {
    console.log("id", item.companyID);
    firebaseInstance
      .database()
      .ref("companies/" + item.companyID + "/image")
      .set("")
      .then(() => {
        console.log("Company image path removed");
        var object = { image: null };
        state.commit("SAVE_COMPANY_IMAGE", object);
      })
      .catch(error => {
        console.log(error, "Error deleting image");
      });
  },
  saveCompanyTaskImage: (state, item) => {
    console.log("saveCompanyTaskImage", item); // companyid, file, index
    var randomNumber = Math.floor(Math.random() * 10000000000000000000000);
    var extension = item.file.name;
    var fileName = randomNumber.toString() + extension;
    extension = extension.substr(extension.lastIndexOf("."), extension.length);
    console.log("item", randomNumber, extension);

    firebaseInstance
      .storage()
      .ref("companyTasksImage/" + fileName)
      .put(item.file)
      .then(snapshot => {
        console.log("Uploaded a blob or file!", snapshot);
        firebaseInstance
          .storage()
          .ref("companyTasksImage/" + fileName)
          .getDownloadURL()
          .then(url => {
            console.log("url", url);
            firebaseInstance
              .database()
              .ref(
                "companies/" +
                  item.companyid +
                  "/companyTasks/" +
                  item.index +
                  "/taskImage"
              )
              .set(url)
              .then(() => {
                console.log("Task image path saved");
                // var object = {url: url}
                // state.commit('SAVE_PROFILE_IMAGE', object)
              })
              .catch(error => {
                console.log(error, "Error saving path to profile image");
              });
          })
          .catch(error => {
            console.log(error, "Error getting task image");
          });
      });
  },
  saveCompanyImage: (state, item) => {
    console.log("item", item);
    firebaseInstance
      .storage()
      .ref("companies/" + item.companyID + "/images/" + item.file.name)
      .put(item.file)
      .then(snapshot => {
        console.log("Uploaded a blob or file!", snapshot);
        firebaseInstance
          .storage()
          .ref()
          .child("companies/" + item.companyID + "/images/" + item.file.name)
          .getDownloadURL()
          .then(url => {
            console.log("url", url);
            firebaseInstance
              .database()
              .ref("companies/" + item.companyID + "/image")
              .set(url)
              .then(() => {
                console.log("Company image path saved");
                var object = { image: url };
                state.commit("SAVE_COMPANY_IMAGE", object);
              })
              .catch(error => {
                console.log(error, "Error saving path to company image");
              });
          })
          .catch(error => {
            console.log(error, "Error getting company image");
          });
      });
  }
};
